/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl, checkIsActive } from "../../../../_helpers";
import { useNavigation } from "../../../_core/useNavigation";

// Thin renderer over the central nav config (see
// `_metronic/layout/_core/navigationConfig.js` + `useNavigation.js`) - this
// component makes NO permission/entitlement decisions itself, it only
// renders whatever `useNavigation()` has already decided is visible. To
// add/change/remove a menu item, edit navigationConfig.js, not this file.
//
// Nesting is capped at one submenu level by design (section -> item ->
// children) - this is the same markup Metronic's KTMenu widget already
// renders as an accordion on tablet/mobile (see
// _metronic/_assets/js/layout/base/aside-menu.js's `submenu: { desktop,
// tablet: "accordion", mobile: "accordion" }` config), so no deeply nested
// flyouts that would be awkward to tap on a phone/WebView.
export function AsideMenuList({ layoutProps }) {
    const location = useLocation();
    const sections = useNavigation();

    const getMenuItemActive = (url, hasSubmenu = false) => {
        return checkIsActive(location, url)
            ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open menu-item-not-hightlighted`
            : "";
    };

    const renderIcon = item =>
        item.svgIcon ? (
            <span className="svg-icon menu-icon">
                <SVG src={toAbsoluteUrl(item.svgIcon)} />
            </span>
        ) : (
            <i className={`svg-icon menu-icon ${item.icon || ""}`}></i>
        );

    const renderLeaf = item => (
        <li key={item.id} className={`menu-item ${getMenuItemActive(item.route)}`} aria-haspopup="true">
            <NavLink className="menu-link" to={item.route}>
                {renderIcon(item)}
                <span className="menu-text">{item.label}</span>
            </NavLink>
        </li>
    );

    const renderChild = child => (
        <li key={child.id} className={`menu-item ${getMenuItemActive(child.route)}`} aria-haspopup="true">
            <NavLink className="menu-link" to={child.route}>
                <i className="menu-bullet menu-bullet-dot">
                    <span />
                </i>
                <span className="menu-text">{child.label}</span>
            </NavLink>
        </li>
    );

    const renderParent = item => (
        <li
            key={item.id}
            className={`menu-item menu-item-submenu ${getMenuItemActive(item.children[0].route, true)}`}
            aria-haspopup="true"
            data-menu-toggle="hover"
        >
            <NavLink className="menu-link menu-toggle" to={item.children[0].route}>
                {renderIcon(item)}
                <span className="menu-text">{item.label}</span>
            </NavLink>
            <div className="menu-submenu">
                <i className="menu-arrow" />
                <ul className="menu-subnav">
                    <li className="menu-item menu-item-parent" aria-haspopup="true">
                        <span className="menu-link">
                            <span className="menu-text">{item.label}</span>
                        </span>
                    </li>
                    {item.children.map(renderChild)}
                </ul>
            </div>
        </li>
    );

    return (
        <>
            {/* begin::Menu Nav */}
            <ul className={`menu-nav ${layoutProps.ulClasses}`}>
                {sections.map(section => (
                    <React.Fragment key={section.id}>
                        {section.label && (
                            <li className="menu-section">
                                <h4 className="menu-text">{section.label}</h4>
                                <i className="menu-icon flaticon-more-v2" />
                            </li>
                        )}
                        {section.items.map(item => (item.children ? renderParent(item) : renderLeaf(item)))}
                    </React.Fragment>
                ))}
            </ul>
            {/* end::Menu Nav */}
        </>
    );
}

